import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1000px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .orders {
    width: 100%;
    overflow-x: auto;
    margin-top: 25px;
  }

  .order {
    background-color: #f1f1f1;
    border: 1px solid #0000001c;
    padding: 15px;
    width: 1000px;
    display: flex;
    border-radius: 5px;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .title {
      margin-bottom: 7px;
      font-weight: 600;
      font-size: 14px;
      text-align: left;
      word-wrap: break-word;
      white-space: normal;
    }

    .back {
      display: inline-block;
      border-radius: 50px;
      padding: 6px 12px;
      background-color: #fff;
    }

    button {
      padding: 6px 15px;
      border-radius: 50px;
      font-size: 16px;
      margin-left: 50px;
      max-width: 150px;
      font-weight: 500;
      font-family: Montserrat;
    }
  }
`;
